import React from 'react';

export default function PermissionPrompt({
  requestingPermissions,
  onRequestPermissions,
  onDismiss,
}) {
  return (
    <div className="permissions-prompt-card">
      <div className="permissions-prompt-content">
        <div>
          <strong>Toestemmingen instellen</strong>
          <div className="kleine-tekst">
            Sta notificaties, locatie en microfoon toe voor volledige functionaliteit.
          </div>
        </div>
        <div className="permissions-prompt-actions">
          <button className="krinkels-button" onClick={onRequestPermissions} disabled={requestingPermissions}>
            {requestingPermissions ? 'Bezig...' : 'Toestemmingen toestaan'}
          </button>
          <button className="krinkels-button secondary" onClick={onDismiss} disabled={requestingPermissions}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
